// Flagi nowego UI z `GET /flags` — JEDNO pobranie na kartę przeglądarki, współdzielone przez wszystkich konsumentów.
// `useFlagiUi()` → { gotowe, uiNowe, kreatorAsync, poradaAsync, umowyAsync, badaniaAsync, blad }.
// Brak pola w odpowiedzi = false (nigdy „domyślnie włączone”). Błąd pobrania NIE jest zapamiętywany (kolejny montaż ponawia).
import { useEffect, useState } from "react";
import api from "@/lib/api";

const WYNIK_POCZATKOWY = {
  gotowe: false, uiNowe: false, kreatorAsync: false, poradaAsync: false, umowyAsync: false, badaniaAsync: false, blad: null,
};

let obietnica = null;
let ostatni = null;
let uzytkownikFlag = null;

/** Zamienia odpowiedź `/flags` na kształt hooka. Tylko jawne `true` włącza flagę. */
export function flagiZOdpowiedzi(dane) {
  const d = dane && typeof dane === "object" ? dane : {};
  return {
    gotowe: true,
    uiNowe: d.ui_nowe === true,
    kreatorAsync: d.kreator_async === true,
    poradaAsync: d.porada_async === true,
    umowyAsync: d.umowy_async === true,
    badaniaAsync: d.badania_async === true,
    blad: null,
  };
}

function pobierz() {
  if (!obietnica) {
    obietnica = api.get("/flags", { timeout: 15000 })
      .then((res) => {
        ostatni = flagiZOdpowiedzi(res?.data);
        return ostatni;
      })
      .catch((err) => {
        obietnica = null; // błąd nie jest zapamiętywany
        ostatni = null;
        return { ...WYNIK_POCZATKOWY, gotowe: true, blad: err };
      });
  }
  return obietnica;
}

/** Do testów i do wymuszenia ponownego odczytu. */
export function resetujFlagi() {
  obietnica = null;
  ostatni = null;
}

/**
 * Flagi (w tym `ui_nowe`) są per konto, a wylogowanie nie przeładowuje strony: zmiana użytkownika unieważnia pamięć flag,
 * żeby druga osoba w tej samej karcie nie dostała flag pierwszej. Wołać przed `useFlagiUi()`.
 */
export function ustawUzytkownikaFlag(id) {
  const nowy = id === undefined || id === null ? null : String(id);
  if (nowy === uzytkownikFlag) return;
  uzytkownikFlag = nowy;
  resetujFlagi();
}

export function useFlagiUi() {
  const [wynik, setWynik] = useState(() => ostatni || WYNIK_POCZATKOWY);
  useEffect(() => {
    let zyje = true;
    pobierz().then((w) => {
      if (zyje) setWynik(w);
    });
    return () => {
      zyje = false;
    };
  }, []);
  return wynik;
}

export default useFlagiUi;
